import PersonalGoalsReport from './PersonalGoalsReport';

export default PersonalGoalsReport;

